<template>
    <div  class="common-margin">
        <el-card class="mar_bot">
            <common-top-form :model="formModel" :show="false" :submitService="submitService" :submitData="submitData" @success="onSuccess">
                    <select-organs v-model="formModel.tatSimpleId"></select-organs>
                    <el-form-item label="交易时间">
                    <el-date-picker
                        v-model="time"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
            </common-top-form>
        </el-card>

        <el-row :gutter="30" class="mar_bot">
            <el-col :span="12">
                <el-card>
                    <p class="commonTitle">交易笔数占比</p>
                    <tran-total-chart  ref="jyzezb" :params="tranTotalData"></tran-total-chart>
                </el-card>
            </el-col>
            <el-col :span="12">
                <el-card>
                    <p class="commonTitle">会员占比</p>
                    <mem-total-chart ref="hyzb" :params="memTotalData"></mem-total-chart>
                </el-card>
            </el-col>
        </el-row>
        <el-card class="mar_bot">
            <p class="commonTitle">交易额走势图</p>
            <tran-money-chart ref="jyezst" :params="tranMoneyData"></tran-money-chart>
        </el-card>

    </div>

</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import TranTotalChart from '../../fragment/echarts/TranTotalChart'
    import MemTotalChart from '../../fragment/echarts/MemTotalChart'
    import SelectOrgans from 'components/business/SelectOrgans'
    import TranMoneyChart from '../../fragment/echarts/TranMoneyChart'

    import StatisticsService from 'service/StatisticsService'
    import OrganService from 'service/OrganService'
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'
    import TimeRange from 'service/constant/TimeRange'

    export default {
        name: "GraphStatistics",
        components: {
            MemTotalChart,
            TranTotalChart,
            TranMoneyChart,
            CommonTopForm,
            SelectOrgans,
        },
        data() {
            return {
                formModel: {
                    tatSimpleId: '',
                    shortName: '',
                    defaultTime: '7',
                },
                all: [{
                    id: '',
                    simpleName: '全部'
                }],
                submitService: StatisticsService.tranCountCake,
                time: TimeRange.dayRange,
                tranTotalData: {},
                memTotalData: {},
                tranMoneyData: {},
                // topTranData: [],
                // topNumData: [],
                // topMemData: [],
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                topType:'1',
            }
        },
        mixins: [loadMixin, dialogMixin],
        computed: {
            submitData() {

                if (this.time == null || this.time == '') {
                    this.time = [];
                }
                const params = {
                    tatSimpleId: this.formModel.tatSimpleId,
                    userId: this.userId
                };
                if (this.time.length) {
                    params.startTime = this.time[0];
                    params.endTime = this.time[1];
                }
                return params;
            },
            ...mapGetters(['serverType','tatId','userId'])
        },
        mounted() {

            this.getList();
            window.addEventListener('resize', this.chartResize);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.chartResize);
        },
        methods: {
            //调整窗口
            chartResize() {
                this.$refs.jyzezb.charts.resize();
                this.$refs.hyzb.charts.resize();
                this.$refs.jyezst.charts.resize();
            },
            getList() {
                this.doLoad(StatisticsService.tranCountCake, this.submitData, res => {
                    this.doCheck(res, res => {
                        this.onSuccess(res)
                    });
                }, '信息获取失败')
            },
            onSuccess(res) {
                const result = res.contents;
                this.tranTotalData = {
                    fastTotal : result.fastTotal,
                    total : result.total,
                    perfTotal : result.perfTotal,
                    quickTotal : result.quickTotal,
                };
                this.memTotalData = {
                    regisTotal : result.regisTotal,
                    authTotal : result.authTotal,
                    lvTotal : result.lvTotal,
                    noAuthTotal : result.noAuthTotal,
                };
                this.tranMoneyData = {
                    quickList : result.quickList,
                    perfList : result.perfList,
                    fastList : result.fastList,
                    timeList : result.timeList,
                };
            },
        },

    }
</script>

<style scoped>
    .mar_bot{
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/StatisticsManage/GraphStatistics.vue